export default __webpack_public_path__ + "static/media/front-example.46fe1a23.png";